var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from "react";
export var useZoom = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.initialScale, initialScale = _c === void 0 ? 1 : _c, _d = _b.step, step = _d === void 0 ? 0.5 : _d, _e = _b.bounds, bounds = _e === void 0 ? {} : _e;
    var _f = __read(useState(initialScale), 2), scale = _f[0], setScale = _f[1];
    var _g = bounds.upper, upper = _g === void 0 ? 3 : _g, _h = bounds.lower, lower = _h === void 0 ? 1 : _h;
    var zoomIn = function () { return setScale(function (prevScale) { return prevScale + step <= upper ? prevScale + step : upper; }); };
    var zoomOut = function () { return setScale(function (prevScale) { return prevScale - step >= lower ? prevScale - step : lower; }); };
    return {
        scale: scale,
        zoomIn: zoomIn,
        zoomOut: zoomOut,
        bounds: {
            upper: upper,
            lower: lower,
        },
        styles: {
            transform: "scale(".concat(scale, ")"),
            transformOrigin: "0 0",
            transition: "transform 0.3s ease-in-out",
            touchAction: "pan-x pan-y",
        },
    };
};
